import { render } from "./PvqWheelChart.vue?vue&type=template&id=02113681"
import script from "./PvqWheelChart.vue?vue&type=script&lang=js"
export * from "./PvqWheelChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__